const CommonValidationErrorKeys = {
  ERROR_CONTACT_CUSTOMER_SERVICE: "errorContactCustomerService",
}

export default CommonValidationErrorKeys
